import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../components/Common/ProtectedRouteBuiltIn";
import Login from "../login/Login";
import Trafic from "../pages/Dashboard/Trafic";
import Operations from "../pages/Dashboard/Operations";
import Users from "../pages/Users/Users";
import Employees from "../pages/Users/Employees";
import Trips from "../pages/Dashboard/Trips";
import Finance from "../pages/Dashboard/Finance";
import Clients from "../pages/Dashboard/Clients";
import Inventory from "../pages/Dashboard/Inventory";
import Dashboard from "../pages/Dashboard/Dashboard";
import ClientPayments from "../pages/Finances/ClientPayments";
import PayedTrips from "../pages/Finances/PayedTrips";
import CalculadoraPage from "../pages/Finances/Calculadora";
import Paysheet from "../pages/Finances/Paysheet";
import Diesel from "../pages/Finances/Diesel";
import Maintenance from "../pages/Maintenance/Maintenance";
import Fumigation from "../pages/Maintenance/Fumigation";
import Cleaning from "../pages/Maintenance/Cleaning";
import Tag from "../pages/Finances/Tag";
import FinancialDashboardPage from "../pages/Finances/FinancialDashboard";
import Calendar from "../pages/Calendar";
import Usage from "../pages/Usage";
import TripRequestsPage from "../pages/Cliente/TripRequests";
import ManageTripRequestsPage from "../pages/Dashboard/ManageTripRequests";
import Manual from "../pages/Manual/Manual";
import CompanySettingsPage from "../pages/Dashboard/CartaPorteConfigPage";
import ChangePasswordPage from "../pages/ChangePassword";

// Subscription Management Components
import CompanyProfile from "../components/Subscription/CompanyProfile";
import UserManagement from "../components/Subscription/UserManagement";
import Settings from "../components/Subscription/Settings";
import Pricing from "../pages/Pricing";

import Signup from "../pages/Signup";
import VerifyEmail from "../pages/VerifyEmail";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
// import FourHandedFourError from "../pages/FourHandedFourError";

const AppRouter = () => (
  <>
    {/* Protected Routes - require authentication */}
    {/* <ProtectedRoute path="/" exact component={Dashboard} /> */}
    <ProtectedRoute path="/trafico/" exact component={Trafic} />
    <ProtectedRoute path="/operaciones/" exact component={Operations} />
    <ProtectedRoute path="/usuarios/" exact component={Users} />
    <ProtectedRoute path="/empleados/" exact component={Employees} />
    <ProtectedRoute path="/viajes/" exact component={Trips} />
    <ProtectedRoute path="/rutas/" exact component={Finance} />
    <ProtectedRoute path="/clientes/" exact component={Clients} />
    <ProtectedRoute path="/flotilla/" exact component={Inventory} />
    <ProtectedRoute path="/finanzas/pagos-del-cliente/" exact component={ClientPayments} />
    <ProtectedRoute path="/finanzas/viajes-pagados/" exact component={PayedTrips} />
    <ProtectedRoute path="/finanzas/calculadora/" exact component={CalculadoraPage} />
    <ProtectedRoute path="/finanzas/nomina/" exact component={Paysheet} />
    <ProtectedRoute path="/finanzas/disel/" exact component={Diesel} />
    <ProtectedRoute path="/mantenimiento/mantenimiento/" exact component={Maintenance} />
    <ProtectedRoute path="/mantenimiento/fumigacion/" exact component={Fumigation} />
    <ProtectedRoute path="/mantenimiento/limpieza/" exact component={Cleaning} />
    <ProtectedRoute path="/finanzas/tag/" exact component={Tag} />
    <ProtectedRoute path="/finanzas/dashboard/" exact component={FinancialDashboardPage} />
    <ProtectedRoute path="/calendar/" component={Calendar} />
    <ProtectedRoute path="/calendario-cliente/" component={Calendar} />
    <ProtectedRoute path="/solicitudes-viaje/" component={TripRequestsPage} />
    <ProtectedRoute path="/gestionar-solicitudes/" component={ManageTripRequestsPage} />
    <ProtectedRoute path="/usage/" component={Usage} />
    <ProtectedRoute path="/manual/" component={Manual} />
    <ProtectedRoute path="/company-settings/" exact component={CompanySettingsPage} />
    <ProtectedRoute path="/cambiar-contrasena/" exact component={ChangePasswordPage} />
    <Route path="/pricing/" component={Pricing} />

    {/* Subscription Management Routes */}
    <ProtectedRoute path="/company/profile/" exact component={CompanyProfile} />
    <ProtectedRoute path="/company/users/" exact component={UserManagement} />
    <ProtectedRoute path="/company/settings/" exact component={Settings} />

    {/* <ProtectedRoute path="/error-404/" component={FourHandedFourError} /> */}

    {/* Public Routes - no authentication required */}
    <Route path="/" exact component={Login} />
    <Route path="/privacy-policy" exact component={PrivacyPolicy} />
    <Route path="/terms-of-service" exact component={TermsOfService} />
    <Route path="/signup" exact component={Signup} />
    <Route path="/verificar-email/:token" exact component={VerifyEmail} />
    <Route path="/login" exact component={Login} />
    <Route path="/recuperar-contrasena" exact component={ForgotPassword} />
    <Route path="/restablecer-contrasena/:token" exact component={ResetPassword} />
  </>
);

export default AppRouter;
